import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse
} from '@angular/common/http';
import { Student, HomeUnitChange, ChurchUnit } from '../../models';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class StudentsDataService {
  private baseUrl = 'api/students';

  constructor(private http: HttpClient) {}

  /**
   * Look for a 404 and turn it into a NULL.
   */
  private handleLookupError(error: HttpErrorResponse) {
    if (error.status === 404) {
      return of(null);
    }

    return throwError('Unable to load student');
  }

  /**
   * Gets the student based on the I-Number or BYU-I Email address.
   */
  getStudent(iNumberOrEmail: string): Observable<Student> {
    return this.http
      .get<Student>(`${this.baseUrl}/${iNumberOrEmail}`)
      .pipe(catchError(this.handleLookupError));
  }

  /**
   * Gets the home unit change histories for the given student.
   */
  getHomeUnitChanges(iNumber: string): Observable<HomeUnitChange[]> {
    return this.http.get<HomeUnitChange[]>(
      `${this.baseUrl}/${iNumber}/home-unit-histories`
    );
  }

  /**
   * Updates the person's home unit.
   */
  updateHomeUnit(iNumber: string, churchUnit: ChurchUnit) {
    return this.http.put(`${this.baseUrl}/${iNumber}/home-unit`, {
      unitNumber: churchUnit.unitNumber
    });
  }
}
